export * from './ajax'
export * from './selects'
export * from './qrcodes'



// WEBPACK FOOTER //
// ./src/api/index.js